import React from 'react';
import { Form, Input, InputNumber } from 'antd';
import InputRequired from './InputRequired';

const FormItem = Form.Item;

// Input type maybe text or password
export default (props) => {
  const {
    getFieldDecorator,
    required,
    fieldName,
    limitValue,
    label,
    type,
    value,
    placeholder,
    disable
  } = props;
  let labelConvert = required ? <InputRequired name={label} /> : label;
  let limitValueData = limitValue ? limitValue : {};
  if (type === 'vnd') {
    return (
      <FormItem label={labelConvert}>
        {getFieldDecorator(fieldName, {
          rules: [
            { required: required, message: `Cần điền ${label}`, ...limitValueData },
          ],
          initialValue: value
        })(
          <InputNumber
            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
            style={{ width: '100%' }}
          />
        )}
      </FormItem>
    )
  } else if (type === 'numDouble') {
    return (
      <FormItem label={labelConvert}>
        {getFieldDecorator(fieldName, {
          rules: [
            { required: required, message: `Cần điền ${label}`, ...limitValueData },
          ],
          initialValue: value
        })(
          <InputNumber
            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
            style={{ width: '100%' }}
            step={0.1}
          />
        )}
      </FormItem>
    )
  } else if (type === 'phone') {
    return (
      <FormItem label={labelConvert}>
        {getFieldDecorator(fieldName, {
          rules: [
            { required: required, message: `Cần điền ${label}`, ...limitValueData },
          ],
          initialValue: value
        })(
          <InputNumber
            parser={value => '0' + value}
            style={{ width: '100%' }}
          />
        )}
      </FormItem>
    )
  } else {
    return (
      <FormItem label={labelConvert}>
        {getFieldDecorator(fieldName, {
          rules: [
            { required: required, message: `Cần điền ${label}`, ...limitValueData },
          ],
          initialValue: value
        })(
          <Input placeholder={placeholder} type={type} disabled={disable} />
        )}
      </FormItem>
    )
  }
}